module.exports = __webpack_public_path__ + "imgs/SPLC.7ab55538f1b88e11aea5ae084d15e9ab.png";